import { convertPlanJSON } from "@dvsproj/ipat-core/planUtils";
import { downloadFileFromBase64 } from "../elements/Link";

import bomItemFactory from "../../store/types/bomItemFactory";
import { UserCsvExport } from "../../utils/csv/user-csv-export";
import { convertBlobToBase64 } from "../../utils/uiUtils";
import { convertBomListByBoxes } from "../../utils/bomUtils";

export async function handleDownloadPlanClick(plan) {
    if (plan != null) {
        console.debug(
            "Download file. elements count = " + plan.elements.length,
            plan.bomItems.length
        );

        let planJSON = plan.toJSON;
        if (plan.background) {
            const { width, height, src } = plan.background;
            planJSON.background = {
                width,
                height,
                src,
            };
        }

        downloadFileFromBase64(
            `data:application/json;charset=utf-8,%EF%BB%BF` +
            btoa(JSON.stringify(convertPlanJSON(planJSON, "10cm"))),
            "plan.json"
        );
    }
}

export async function handleDownloadCsvClick(intl, settingsState, bomItems, planName, pricesDictionary) {
    const { formatMessage } = intl;

    const planBomItems = convertBomListByBoxes(settingsState, bomItems ?? [])
        .map((e) => bomItemFactory(e, pricesDictionary))
        .filter(({ name, quantity }) => name != null && quantity > 0);

    const filename =
        formatMessage(
            {
                id: "texts.steps.bom.popup.csvFile.fileName",
            },
            { planName }
        ) + ".csv";

    const csvExport = new UserCsvExport(intl, planBomItems);

    csvExport.generate();
    const blob = csvExport.getToBlob();

    const base64Data = await convertBlobToBase64(blob);

    downloadFileFromBase64(base64Data, filename);
}

export async function handleDownloadImageClick(planId, email, plan, currentStep, calcApi) {
    if (plan != null) {
        let planJSON = plan.toJSON;
        if (plan.background) {
            const { width, height, src } = plan.background;
            planJSON.background = {
                width,
                height,
                src,
            };
        }

        const layouts = {};
        [
            { name: "background", step: 0 },
            { name: "overlay", step: 0 },
            { name: "grid", step: 0 },
            { name: "area", step: 1 },
            { name: "trenches", step: 4 },
            { name: "sprinkler", step: 3 },
            { name: "systemElement", step: 2 },
            { name: "tubing", step: 4 },
            { name: "pipeline", step: 4 },
        ]
            .filter(({ step }) => step <= currentStep)
            .forEach(({ name }) => (layouts[name] = 0));

        const textsVisibility = {
            areaWatermark: currentStep === 1,
            sprinklerElements: currentStep > 3,
            sprinklersIrrigation: currentStep === 3,
            sprinklersTexts: currentStep === 3,
        };

        const blob = await calcApi.generateImage(
            planId,
            email,
            planJSON,
            layouts,
            textsVisibility
        );

        downloadFileFromBase64(blob, "image.png");
    }
}
